<template>
	<div class="main" v-loading.fullscreen="isLoad" router element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb class="bnone">
			<el-breadcrumb-item>系统设置</el-breadcrumb-item>
			<el-breadcrumb-item>小程序参数配置</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form ref="form" label-position="right" :model="item" label-width="auto" show-message inline-message
			status-icon>
			<el-divider content-position="left">微信小程序</el-divider>
			<el-form-item label="Appid">
				<el-input v-model="item.appid"></el-input>
			</el-form-item>
			<el-form-item label="Secret">
				<el-input v-model="item.app_secret"></el-input>
			</el-form-item>
			<el-form-item label="分享标题">
				<el-input v-model="item.share_title"></el-input>
			</el-form-item>
			<el-form-item label="分享封面">
				<el-upload
						class="single-image"
						list-type="single-image"
						:on-success="(value) => uploadSuccess('share_thumb', value)"
						:show-file-list="false"
						:action="app_url + '/store/uploader/upload'">
					<i class="icon el-icon-plus" v-if="!item.share_thumb"></i>
					<img :src="item.share_thumb" v-else>
				</el-upload>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" v-auth="['store/setting/appletEdit']">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				shareThumb: []
			}
		},
		created() {
			this.loadItem()
		},
		methods: {
			loadItem() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('/store/setting/applet', {})
					.then(res => {
						this.isLoad = !this.isLoad
						if (res.data.detail) {
							this.item = res.data.detail
						}

					})
				// .catch(() => {
				// 	this.isLoad = !this.isLoad
				// })
			},
			submit() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.post('/store/setting/appletEdit', this.item)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$notify.success({
							message: '保存成功'
						});
						this.loadItem()
					})
				// .catch(() => {
				// 	this.isLoad = !this.isLoad
				// })
			},
			uploadError() {
				this.$notify.error({
					message: '上传失败'
				});
			},
			uploadSuccess(key, res, file) {
				this.item[key] = res.data.fileInfo.external_url
				this.$forceUpdate()
			},
			uploadRemove: function() {
				this.shareThumb = []
			},
		}
	}
</script>
<style>
</style>
